import { ErrorBoundary } from "react-error-boundary";
import { FormattedMessage } from "react-intl";
import { styled } from "@mui/material/styles";
import { pxToRem } from "@getbread/dough";
import type { FCWithChildren } from "../../api-client/resources/types/sharedTypes";
import { logger } from "../../logger";
import { LinkButton } from "../shared/LinkButton";
import { usePublicPath } from "../../utils/usePublicPath";
import { reloadPage } from "../../utils/helpers";
import { HeaderText } from "../shared/SubNavBar";

const Header = styled(HeaderText)`
	font-size: ${pxToRem(36)};
	font-weight: bold;
`;

const Content = styled("div")`
	color: ${(props) => props.theme.palette.primary.main};
	margin-top: var(--space-s);
	font-size: ${pxToRem(24)};
	font-weight: bold;
`;

const Container = styled("div")`
	margin: var(--space-xxxl) var(--space-l);
	text-align: center;
	display: flex;
	flex-direction: column;
	align-items: center;
`;

const Icon = styled("img")`
	margin: var(--space-xxxl) 0;
`;

export const GenericErrorMessage = () => {
	const publicPath = usePublicPath();
	return (
		<Container data-testid="generic-error-message">
			<Header>
				<FormattedMessage defaultMessage="Oh no!" />
			</Header>
			<Content>
				<FormattedMessage defaultMessage="There has been an error. Please reload the page to try again." />
			</Content>

			<Icon src={`${publicPath}/cloud.svg`} alt="" width="124" height="124" aria-hidden />
			<LinkButton onClick={reloadPage} data-testid="reload-button">
				<FormattedMessage defaultMessage="Reload page" />
			</LinkButton>
		</Container>
	);
};

export const GenericErrorBoundary: FCWithChildren = ({ children }) => (
	<ErrorBoundary
		FallbackComponent={GenericErrorMessage}
		onError={(error, errorInfo) => {
			logger.error({ error, errorInfo });
		}}
	>
		{children}
	</ErrorBoundary>
);
